// extracted by mini-css-extract-plugin
module.exports = {"pageSection":"EXPIw","gridContainer":"_6s-Lx","borderTop":"BaJb8","darkBackground":"_3wjYB","spaceTop":"_12lTN","spaceBottom":"_1Z36o"};